// First-touch referral attribution.
//
// A visitor arriving via ?ref=CODE (or /r/:code) is credited to the FIRST
// referrer they ever came through. Later/different ?ref= values do NOT
// overwrite, matching "якщо ще не було іншого реферала який раніше привів".
// See REFERRALS_AND_ANALYTICS.md §5.

const REF_COOKIE = 'dys_ref';
const REF_DAYS = 90;

function setCookie(name: string, value: string, days: number) {
    try {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    } catch {
        // ignore (SSR / disabled cookies)
    }
}

function getCookie(name: string): string | null {
    try {
        const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
        return match ? decodeURIComponent(match[1]) : null;
    } catch {
        return null;
    }
}

/** The referral code this visitor is attributed to (first-touch), or null. */
export function getAttributedRef(): string | null {
    return getCookie(REF_COOKIE);
}

/**
 * Capture a referral code as first-touch. Returns the code if it was newly
 * set (i.e. this is the first referrer for this visitor), else null - callers
 * use that to fire the one-time `ref_click` event.
 */
export function captureRef(code: string | null | undefined): string | null {
    const clean = (code || '').trim().slice(0, 64);
    if (!clean) return null;
    if (getCookie(REF_COOKIE)) return null; // first-touch wins - keep the original
    setCookie(REF_COOKIE, clean, REF_DAYS);
    return clean;
}

/** Read ?ref= from a URL search string (e.g. window.location.search). */
export function readRefParam(search: string): string | null {
    try {
        return new URLSearchParams(search).get('ref');
    } catch {
        return null;
    }
}

/**
 * Throttle visit logging to once per visitor per code per day, so opening the
 * same referral link repeatedly (or a tab reload) doesn't flood `events`.
 * Returns true the first time today, false afterwards. Unique-visitor counts
 * stay accurate (one row/visitor/day) and total rows stay bounded.
 */
export function shouldLogVisitToday(code: string): boolean {
    try {
        const day = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
        const key = `dys_visit:${code}:${day}`;
        if (localStorage.getItem(key)) return false;
        localStorage.setItem(key, '1');
        return true;
    } catch {
        return true;
    }
}
